const app = globalThis?.app || {};
const defaultEnv = globalThis?.defaultEnv || {};
const envOverrides = globalThis?.env || {};
const env = { ...defaultEnv, ...envOverrides };

// App configuration
export const MODULES = env.MODULES;
export const BACKEND_HOST = env.BACKEND_HOST || app.BACKEND_HOST;
export const SERVICE_HOST = env.SERVICE_HOST;

// AD Configuration
export const AD_AUTHORITY = env.AD_AUTHORITY || app.AD_AUTHORITY;
export const AD_CLIENT_ID = env.AD_CLIENT_ID || app.AD_CLIENT_ID;

// API Urls
export const CONFIGURATION_API_PATH = env.CONFIGURATION_API_PATH;
export const RESOURCES_API_PATH = env.RESOURCES_API_PATH;
export const LOGIN_API_PATH = env.LOGIN_API_PATH;
export const INSIGHTS_API_PATH = env.INSIGHTS_API_PATH;

export const DOCUMENTATION_URL = env.DOCUMENTATION_URL;

export const ENVIRONMENT_NAME = env.ENVIRONMENT_NAME;
export const ENVIRONMENT_CONTEXT = env.ENVIRONMENT_CONTEXT;
